import { render, staticRenderFns } from "./ques4.vue?vue&type=template&id=4b157b8b"
import script from "./ques4.vue?vue&type=script&lang=js"
export * from "./ques4.vue?vue&type=script&lang=js"
import style0 from "./ques4.vue?vue&type=style&index=0&id=4b157b8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports